import { TextField } from '@material-ui/core/';

import React, { FC, useState } from 'react';
import styled from 'styled-components';
import Text from 'components/Text';

import { onSurfaceHigh } from 'styles/colors';
import ContinueButton from './QuizContinueButton';
import { Question } from 'types/quiz';

interface InputProp {
  question: Question;
  onContinue: (value: string) => void;
  handleSkip: () => void;
}

const Title = styled(Text)`
  text-align: center;
`;

const SubTitle = styled(Text)`
  text-align: center;
  font-size: 0.75rem;
  font-weight: 400;
  margin-top: 0.75rem;
`;

const Underline = styled.div`
  width: 1.8125rem;
  height: 0.125rem;
  background-color: ${({ theme }) => theme.colors.dark60};
`;

const SkipText = styled(Text)`
  font-family: Inter;
  margin-top: 1.9rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  margin-bottom: -0.0625rem;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  margin-top: 1.5rem;
`;

const Skip = styled.div`
  margin-bottom: 5.625rem;
`;

const InputWrapper = styled.div`
  width: 100%;
  max-width: 21.4375rem;
  margin-top: 1.5rem;
  .MuiOutlinedInput-root {
    background-color: ${({ theme }) => theme.colors.cultured};

    box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08),
      0px 0.5px 2px rgba(96, 97, 112, 0.16);
    padding: 0.8125rem 1rem;

    &.Mui-focused {
      color: ${onSurfaceHigh};
      .MuiInputBase-input {
        &::placeholder {
          opacity: 0.5;
        }
      }
    }
    fieldset {
      border-color: transparent;
    }
    &:hover fieldset {
      border-color: ${({ theme }) => theme.colors.green};
    }
    &.Mui-focused fieldset {
      border-color: ${({ theme }) => theme.colors.green};
    }
  }
  .MuiInputBase-input {
    text-align: center;
    color: ${({ theme }) => theme.colors.dark100};
    font-family: Inter;
    font-weight: 500;
    font-size: 0.875rem;

    &::placeholder {
      opacity: 1;
    }
  }
`;

const QuizInput: FC<InputProp> = ({ question, onContinue, handleSkip }) => {
  const [answer, setAnswer] = useState('');
  const isDisabled = answer.trim().length <= 1;
  return (
    <Container>
      <Title type="h3" color="dark100">
        {question.title}
      </Title>
      <SubTitle color="dark100">{question.description}</SubTitle>
      <InputWrapper>
        <TextField
          variant="outlined"
          multiline
          fullWidth
          placeholder={question.inputPlaceholder}
          onChange={e => setAnswer(e.target.value)}
          value={answer}
        />
      </InputWrapper>

      <Skip onClick={handleSkip}>
        <SkipText color="dark60">Skip</SkipText>
        <Underline />
      </Skip>

      <ContinueButton
        title={question?.nextBtnTitle}
        onClick={() => onContinue(answer)}
        disabled={isDisabled}
      />
    </Container>
  );
};

export default QuizInput;
